import React from 'react';
import PropTypes from 'prop-types';
import Logo from './Logo';
import Styles from './header.module.scss';

const Header = props => (
  <header className="signup-header" data-role="header-container">
    <div className={Styles['signup-top']}>
      <Logo />
    </div>
    { typeof props.title === 'string' ?
      <h1 className="signup-title" data-role="header-title">
        {props.title}
      </h1> :
      props.title
    }
    { typeof props.subtitle === 'string' ?
      <p className="signupSubtitle" data-role="header-subtitle">
        {props.subtitle}
      </p> :
      <p className="signupSubtitle" data-role="header-subtitle">
        {/* eslint-disable react/no-array-index-key */}
        {props.subtitle.map((s, i) => <span key={i}>{s}</span>)}
      </p>
    }
  </header>
);

Header.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

Header.defaultProps = {
  subtitle: '',
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.jsx